import { useEffect, useState } from "react";
import { Sparkles, Clock, Flame } from "lucide-react";
import { useT } from "@/context/I18nContext";

function useCountdownToMidnight() {
  const [ms, setMs] = useState(0);
  useEffect(() => {
    const tick = () => {
      const now = new Date();
      const midnight = new Date(now);
      midnight.setHours(24, 0, 0, 0);
      setMs(midnight - now);
    };
    tick();
    const iv = setInterval(tick, 1000);
    return () => clearInterval(iv);
  }, []);
  const h = Math.max(0, Math.floor(ms / 3600000));
  const m = Math.max(0, Math.floor((ms % 3600000) / 60000));
  const s = Math.max(0, Math.floor((ms % 60000) / 1000));
  const pad = (n) => String(n).padStart(2, "0");
  return `${pad(h)}:${pad(m)}:${pad(s)}`;
}

export default function ScarcityBanner({ remaining = 500, total = 500 }) {
  const { locale } = useT();
  const countdown = useCountdownToMidnight();
  const scarce = remaining <= 50;
  return (
    <div
      data-testid="scarcity-counter-banner"
      className={`border-b ${scarce ? "border-amber-500/40 bg-gradient-to-r from-amber-500/20 via-rose-500/15 to-amber-500/20" : "border-cyan-500/20 bg-gradient-to-r from-cyan-500/10 via-blue-500/10 to-indigo-500/10"}`}
    >
      <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-center gap-x-3 gap-y-1 px-4 py-2.5 text-center text-sm">
        {scarce ? (
          <Flame className="h-4 w-4 animate-pulse text-amber-300" />
        ) : (
          <Sparkles className="h-4 w-4 text-cyan-300" />
        )}
        <span className={scarce ? "text-amber-200 font-semibold" : "text-slate-200"}>
          {locale === "en"
            ? scarce ? "Almost sold out - only" : "Lifetime offer limited to 500 licenses - "
            : scarce ? "Quasi esaurito - solo" : "Offerta a vita limitata a 500 licenze - "}
        </span>
        <span
          data-testid="scarcity-remaining"
          className={`mono rounded-md px-2 py-0.5 font-bold ${scarce ? "bg-amber-500/30 text-amber-100" : "bg-slate-900/80 text-cyan-300"}`}
        >
          {remaining}
        </span>
        <span className={scarce ? "text-amber-200" : "text-slate-400"}>
          {locale === "en" ? `of ${total} left` : `di ${total} rimaste`}
        </span>
        <span className="hidden text-slate-500 sm:inline">•</span>
        <span className="flex items-center gap-1.5 text-slate-300">
          <Clock className="h-3.5 w-3.5" />
          <span
            data-testid="scarcity-countdown"
            className="mono text-cyan-300"
          >
            {countdown}
          </span>
          <span className="text-slate-400">
            {locale === "en" ? "until midnight" : "a mezzanotte"}
          </span>
        </span>
      </div>
    </div>
  );
}
